module.exports = __webpack_public_path__ + "static/media/shareShadeLayer.e6068b48.less";